/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.url.signer.rpc.UrlSignerRpc
 */

export const signUrlRpc = {
  serviceName: 'com.hubspot.url.signer.rpc.UrlSignerRpc',
  rpcName: 'signUrl',
  auth: 'app',
  fingerprint: 'oYkYZsjYzMt6It_Q-j1AKhRWScqOzrJE',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const signUrlForFormRpc = {
  serviceName: 'com.hubspot.url.signer.rpc.UrlSignerRpc',
  rpcName: 'signUrlForForm',
  auth: 'app',
  fingerprint: 'oxjPoW6e-vV6It_Q-j1AKhRWScqOzrJE',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};